import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}
export function switchLoginUser(userId, password) {
  const data = {
    userId,
    password
  }
  return request({
    url: '/user/switchUser',
    headers: {
      isToken: true
    },
    method: 'get',
    params: data
  })
}
// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/user/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/verification/index',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}